import React, { useEffect, useState } from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";
import searchIcon from "../assets/search.svg";
import cartIcon from "../assets/cart.svg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config/api";

export default function Navbar() {
  const CART_STORAGE_KEY = "rungdo_cart_v1";
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const syncCartCount = () => {
      try {
        const cart = JSON.parse(localStorage.getItem(CART_STORAGE_KEY) || "[]");
        const count = Array.isArray(cart)
          ? cart.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0)
          : 0;
        setCartCount(count);
      } catch (error) {
        setCartCount(0);
      }
    };

    syncCartCount();
    window.addEventListener("storage", syncCartCount);
    window.addEventListener("cart-updated", syncCartCount);

    return () => {
      window.removeEventListener("storage", syncCartCount);
      window.removeEventListener("cart-updated", syncCartCount);
    };
  }, []);

  useEffect(() => {
    // Prevent double vertical scrolling when mobile overlays are open.
    const shouldLockScroll = showMobileMenu || showSearchModal;
    const originalOverflow = document.body.style.overflow;

    if (shouldLockScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [showMobileMenu, showSearchModal]);

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (!query) {
      setResults([]);
      return;
    }

    try {
      const res = await axios.get(`${API_BASE_URL}/api/products/search?query=${query}`);
      setResults(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const handleResultClick = (slug) => {
    setShowSearchModal(false);
    setSearchQuery("");
    setResults([]);
    navigate(`/product/${slug}`);
  };

  const closeMobileMenu = () => setShowMobileMenu(false);

  return (
    <nav className="navbar">
      <div className="nav-left">
        <button
          type="button"
          className={`mobile-menu-button ${showMobileMenu ? "is-open" : ""}`}
          aria-label="Open menu"
          onClick={() => setShowMobileMenu((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <img
          src={searchIcon}
          alt="search"
          className="nav-icon nav-search-desktop"
          onClick={() => setShowSearchModal(true)}
          style={{ cursor: "pointer" }}
        />
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/e-store">E-Store</Link></li>
        </ul>
      </div>
      <div className="nav-logo">
        <Link to="/"><img src={logo} alt="logo" /></Link>
      </div>
      <div className="nav-right">
        <ul className="nav-links">
          <li><Link to="/paint-calculator">Paint Calculator</Link></li>
          <li><Link to="/about-us">About</Link></li>
        </ul>
        <img
          src={searchIcon}
          alt="search"
          className="nav-icon nav-search-mobile"
          onClick={() => setShowSearchModal(true)}
          style={{ cursor: "pointer" }}
        />
        <button type="button" className="cart-button" onClick={() => navigate("/cart")} aria-label="Open cart">
          <img src={cartIcon} alt="cart" className="nav-icon" />
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </button>
      </div>
      {showMobileMenu && <button type="button" className="mobile-menu-backdrop" onClick={closeMobileMenu} aria-label="Close menu" />}
      <div className={`mobile-menu ${showMobileMenu ? "is-open" : ""}`}>
        <Link to="/" onClick={closeMobileMenu}>Home</Link>
        <Link to="/e-store" onClick={closeMobileMenu}>E-Store</Link>
        <Link to="/paint-calculator" onClick={closeMobileMenu}>Paint Calculator</Link>
        <Link to="/about-us" onClick={closeMobileMenu}>About</Link>
        <button
          type="button"
          className="mobile-menu-cart"
          onClick={() => {
            closeMobileMenu();
            navigate("/cart");
          }}
        >
          Cart {cartCount > 0 ? `(${cartCount})` : ""}
        </button>
      </div>
      {showSearchModal && (
        <div className="search-modal">
          <div className="search-modal-content">
            <button className="close-btn" onClick={() => setShowSearchModal(false)}>×</button>
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={handleSearch}
              autoFocus
            />
            <div className="search-results">
              {results.length > 0 ? (
                results.map((p) => (
                  <div
                    key={p._id}
                    className="search-item"
                    onClick={() => handleResultClick(p.slug)}
                  >
                    {p.name} ({p.category})
                  </div>
                ))
              ) : (
                <div className="search-item">No results found</div>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
